export default __webpack_public_path__ + "static/media/copy_clipboard.2edb9a6a.svg";